import { useState, useEffect } from 'react';
import { MDBAccordion, MDBAccordionItem, MDBCard, MDBCol, MDBRow } from "mdb-react-ui-kit";
import axios from 'axios';
import { useLocation } from 'react-router-dom';

function MenuComponent(props) {
    const items = [
        {menutitle: 'UNIT 1', menudescription: 'Hello',
            leveloneitems: [
                {levelonetitle: 'VOCABULARY VIDEOS', levelonedescription: 'Vocabulary videos', leveltwoitems: [
                    {leveltwotitle: 'VOCABULARY VIDEO', leveltwodescription: 'Vocabulary video of unit', url: './'},
                ]},
                {levelonetitle: 'ACTIVITIES', levelonedescription: 'Interactive Activities', leveltwoitems: [
                    {leveltwotitle: '1. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about phrasal verbs', url: 'http://localhost:3000/?iaid=7'},
                    {leveltwotitle: '2. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about past perfect', url: './'},
                ]},
                {levelonetitle: 'EXAMS', levelonedescription: 'Interactive Exams', leveltwoitems: [
                    {leveltwotitle: '1. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 1', url: './'},
                    {leveltwotitle: '2. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 2', url: './'},
                    {leveltwotitle: '3. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 3', url: './'},
                ]}
            ]
        },
        {menutitle: 'UNIT 2', menudescription: 'My Life',
            leveloneitems: [
                {levelonetitle: 'VOCABULARY VIDEOS', levelonedescription: 'Vocabulary videos', leveltwoitems: [
                    {leveltwotitle: 'VOCABULARY VIDEO', leveltwodescription: 'Vocabulary video of unit', url: './'},
                ]},
                {levelonetitle: 'ACTIVITIES', levelonedescription: 'Interactive Activities', leveltwoitems: [
                    {leveltwotitle: '1. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about phrasal verbs', url: './'},
                    {leveltwotitle: '2. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about past perfect', url: './'},
                    {leveltwotitle: '3. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about past perfect', url: './'},
                ]},
                {levelonetitle: 'EXAMS', levelonedescription: 'Interactive Exams', leveltwoitems: [
                    {leveltwotitle: '1. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 1', url: './'},
                    {leveltwotitle: '2. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 2', url: './'},
                ]}
            ]
        },
        {menutitle: 'UNIT 3', menudescription: 'Tourism',
            leveloneitems: [
                {levelonetitle: 'VOCABULARY VIDEOS', levelonedescription: 'Vocabulary videos', leveltwoitems: [
                    {leveltwotitle: 'VOCABULARY VIDEO', leveltwodescription: 'Vocabulary video of unit', url: './'},
                ]},
                {levelonetitle: 'ACTIVITIES', levelonedescription: 'Interactive Activities', leveltwoitems: [
                    {leveltwotitle: '1. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about phrasal verbs', url: './'},
                    {leveltwotitle: '2. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about past perfect', url: './'},
                    {leveltwotitle: '3. INTERACTIVE ACTIVITY', leveltwodescription: 'Interactive Activity about past perfect', url: './'},
                ]},
                {levelonetitle: 'EXAMS', levelonedescription: 'Interactive Exams', leveltwoitems: [
                    {leveltwotitle: '1. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 1', url: './'},
                    {leveltwotitle: '2. INTERACTIVE EXAM', leveltwodescription: 'Interactive Exam 2', url: './'},
                ]}
            ]
        },
    ];

    const [config, setConfig] = useState({pageheader: "Student's Resources",
                                          pagebodytext: "Digital educational content developed by TEAM elt publishing for Students' access. Enjoy the the following video, interactive activity and interactive exam content. Follow this web site for newly available content each month.",
                                          menucontent: items
                                        });


    // Get query parameters
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const dontPopup = queryParams.get('dontpopup') === 'true';


    async function fetchConfig() {
        try {
            let response = await axios.get('config.json');
            setConfig(response.data);
        } catch (error) {
            console.log(error);
            alert('ERROR: Can not fetch config.json');
        }
    }

    useEffect(() => {
        fetchConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>
            <div className=''>
                <div className='sticky-top d-flex flex-row justify-content-between align-items-center bg-info'>
                    <div className='ps-4 text-light'>
                        <h5>{config.pageheader}</h5>
                    </div>
                    <div className='pe-4'>
                        <img src='images/teamlogo.svg' width='150' height='50' />
                    </div>
                </div>
                <MDBRow>
                    <MDBCol lg='3'></MDBCol>
                    <MDBCol lg='6'>
                        <div className='my-4 px-4'>
                            {config.pagebodytext}
                        </div>
                        <MDBAccordion initialActive={-1} className='px-4'>
                            {config.menucontent.map((menuitem, menuitemindex) => {
                            return (<MDBAccordionItem key={menuitemindex} collapseId={menuitemindex} headerStyle={{fontWeight: 'bold'}} headerTitle={menuitem.menutitle + (menuitem.menudescription && ' - ' + menuitem.menudescription)}>
                                    {menuitem.leveloneitems.map((leveloneitem, leveloneitemindex) => {
                                        return (<div key={leveloneitemindex}>
                                            <strong>{leveloneitem.levelonetitle + (leveloneitem.levelonedescription && ' - ' + leveloneitem.levelonedescription)}</strong>
                                            {leveloneitem.leveltwoitems.map((leveltwoitem, leveltwoitemindex) => {
                                                return (<div key={leveltwoitemindex} className='ms-4'>
                                                    {dontPopup ?
                                                        <a href={leveltwoitem.url} >{leveltwoitem.leveltwotitle}</a>
                                                        :
                                                        <a href={leveltwoitem.url} target='_blank'>{leveltwoitem.leveltwotitle}</a>
                                                    }
                                                    <br /></div>)
                                            })}
                                        </div>)
                                    })}
                                </MDBAccordionItem>)
                            })}
                        </MDBAccordion>
                    </MDBCol>
                    <MDBCol lg='3'></MDBCol>
                </MDBRow>
            </div>
    </>);
}

export default MenuComponent;